import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import {
  AddUpdateTurnoverBid,
  RestTurnoverBid,
  RestTurnoverBidCategory,
} from '@shared/interfaces/turnover-bids.interface';

@Injectable({
  providedIn: 'root',
})
export class TurnoverBidsService {
  constructor(private restApiService: RestapiService) {}

  list(turnoverId: number): Observable<RestTurnoverBid[]> {
    return this.restApiService.getData(`turnover/${turnoverId}/bids`);
  }

  add(model: AddUpdateTurnoverBid): Observable<number> {
    return this.restApiService.create(`turnover/${model.turnoverId}/bids`, model);
  }

  update(model: AddUpdateTurnoverBid): Observable<{}> {
    return this.restApiService.update(`turnover/${model.turnoverId}/bids`, model);
  }

  delete(bidId: number): Observable<{}> {
    return this.restApiService.delete(`turnover/bids/${bidId}`);
  }

  accept(bidId: number): Observable<{}> {
    return this.restApiService.create(`turnover/bids/${bidId}/accept`, {});
  }

  reject(bidId: number, reason: string): Observable<{}> {
    return this.restApiService.create(`turnover/bids/${bidId}/reject`, { reason });
  }

  approve(bidId: number, approved: boolean | null, denyReason?: string): Observable<{}> {
    return this.restApiService.create(`turnover/bids/${bidId}/approve`, { approved, denyReason });
  }

  uploadInvoice(bidId: number, fileUploadId: number): Observable<{}> {
    return this.restApiService.create(`turnover/bids/${bidId}/uploadInvoice`, {
      fileUploadId,
    });
  }

  categoryList(): Observable<RestTurnoverBidCategory[]> {
    return this.restApiService.getData(`turnoverDataBidCategory`);
  }

  addCategory(name: string): Observable<number> {
    return this.restApiService.create(`turnoverDataBidCategory`, {
      name,
    });
  }
}
